import React from 'react';
import { Calendar, Phone } from 'lucide-react';
import { Button } from '../ui/button';

const Hero = ({ t, scrollToSection }) => {
  return (
    <section className="pt-44 pb-20 px-4 bg-gradient-to-br from-navy-50 to-blue-50">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold text-navy-900 mb-6 leading-tight">
            {t.hero.headline}
          </h1>
          <p className="text-xl text-gray-700 mb-10 leading-relaxed">
            {t.hero.subheadline}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg" 
              className="bg-navy-600 hover:bg-navy-700 text-lg px-8 py-6"
              onClick={() => scrollToSection('booking')}
            >
              <Calendar className="mr-2 h-5 w-5" />
              {t.hero.cta}
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-navy-600 text-navy-600 hover:bg-navy-50 text-lg px-8 py-6"
              onClick={() => scrollToSection('contact')}
            >
              <Phone className="mr-2 h-5 w-5" />
              {t.hero.contactUs}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;